/**
 * Toggle expanded copy for Feature with icon blocks (delegated clicks; survives product-rerender DOM swaps).
 * Only one row stays open per `.feature-badge-list` group (accordion behavior).
 */
(function () {
  function closeFeatureExpand(root) {
    var panel = root.querySelector('.wd-feature-with-icon__details');
    var btn = root.querySelector('.wd-feature-with-icon__toggle');
    if (panel) {
      panel.classList.remove('active');
      panel.setAttribute('aria-hidden', 'true');
    }
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
    }
  }

  document.body.addEventListener('click', function (event) {
    var toggle = event.target.closest('.wd-feature-with-icon__toggle');
    if (!toggle) {
      return;
    }
    var root = toggle.closest('[data-wd-feature-expand]');
    if (!root) {
      return;
    }
    var panel = root.querySelector('.wd-feature-with-icon__details');
    if (!panel) {
      return;
    }
    event.preventDefault();
    var willOpen = !panel.classList.contains('active');

    if (willOpen) {
      var group = root.closest('.feature-badge-list');
      if (group) {
        group.querySelectorAll('[data-wd-feature-expand]').forEach(function (otherRoot) {
          if (otherRoot !== root) {
            closeFeatureExpand(otherRoot);
          }
        });
      }
    }

    panel.classList.toggle('active', willOpen);
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    panel.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
  });
})();
